import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IOutputService = ( createDecorator('outputService'));
export { IOutputService };
